<header class="header">
  <div class="header-menu-icon" (click)="openNavigation()"><i class="fa-light fa-bars"></i></div>
  <div class="header-branding">
    <a routerLink="/dashboard"><img [src]="'logo_large' | providerImage" [alt]="'logo_large' | providerImage: 'altText'" /></a>
  </div>
  <div class="header-actions">
    <div class="header-action" (click)="onLogOutClicked()"><i class="fa-light fa-arrow-right-from-bracket"></i></div>
  </div>
</header>
